import { defineStore } from "pinia";
import { useUserStore } from "@/store/modules/user";
import { useDomainGroupStore } from "@/store/modules/domainGroup";
import { useDomainStore } from "@/store/modules/domain";
import { useDomainVersionStore } from "@/store/modules/domainVersion";
import { useCycleStore } from "@/store/modules/cycle";
import { useStepStore } from "@/store/modules/step";
import { useExaminationStore } from "@/store/modules/examination";
import { useCompetenceStore } from "@/store/modules/competence";
import { useCertificationProjectStore } from "@/store/modules/certificationProject";

export const useMainStore = defineStore("main", {
  state: () => ({
    initFetchDone: false,
  }),

  getters: {
    getInitFetchDone: (state) => state.initFetchDone,
  },

  actions: {
    async initFetch() {
      const userStore = useUserStore();
      const domainGroupStore = useDomainGroupStore();
      const domainStore = useDomainStore();
      const domainVersionStore = useDomainVersionStore();
      const cycleStore = useCycleStore();
      const stepStore = useStepStore();
      const examinationStore = useExaminationStore();
      const competenceStore = useCompetenceStore();
      const certificationProjectStore = useCertificationProjectStore();

      const metadata = {
        pagination: {
          page_size: 10000,
        },
      };

      await Promise.all([
        userStore.fetchCurrentUser(),
        domainGroupStore.fetchAllDomainGroups({}),
        domainStore.fetchAllDomains({}),
        domainVersionStore.fetchAllDomainVersions({}),
        cycleStore.fetchAllCycles({}),
        stepStore.fetchAllSteps({}),
        examinationStore.fetchAllExaminations({}),
        competenceStore.fetchAllCompetences({}),
        certificationProjectStore.fetchMyCertificationProjects(metadata),
      ]);

      this.setInitFetch(true);
    },

    async publicFetch() {
      const domainStore = useDomainStore();
      await domainStore.fetchPublicDomains({});
    },

    setInitFetch(status) {
      this.initFetchDone = status;
    },
  },
});
